export default __webpack_public_path__ + "static/media/energySchedule.2d30d356.png";